export default __webpack_public_path__ + "static/landscape-e762d80e3ca9a8039d8e19080ed9f5cf.png";